import { OBJECT } from '@pkg/config/sanity/schemas';
import { logger } from '@pkg/logger';
import { LinkFieldType, type ExternalLink, type GeneralLink, type InternalLink, type SSULink } from '@pkg/sanity-utils/linkQueries';
import type { LinkType } from '../types';

const linkTypeMap = {
  [LinkFieldType.INTERNAL]: OBJECT.NAVIGATION_LINK_INTERNAL,
  [LinkFieldType.EXTERNAL]: OBJECT.NAVIGATION_LINK_EXTERNAL,
  [LinkFieldType.SSU]: OBJECT.NAVIGATION_LINK_SSU,
} as const;

/**
 * Converts a Sanity `GeneralLink` into a `LinkType` for CustomLink / navigation.
 */
export const convertGeneralLinkToLinkType = (
  generalLink: GeneralLink,
  title?: string,
  _key?: string,
  newWindow = true,
) => {
  const base: Partial<LinkType> = {
    _type: linkTypeMap[generalLink.linkType],
    _key,
    title,
  };

  if (base._type === OBJECT.NAVIGATION_LINK_INTERNAL && generalLink.linkType === LinkFieldType.INTERNAL) {
    return {
      ...base,
      reference: generalLink.reference,
      internalAnchor: generalLink.internalAnchor,
      newWindow,
    } as InternalLink;
  }

  if (base._type === OBJECT.NAVIGATION_LINK_EXTERNAL && generalLink.linkType === LinkFieldType.EXTERNAL) {
    return {
      ...base,
      url: generalLink.external,
      newWindow,
    } as ExternalLink;
  }

  if (base._type === OBJECT.NAVIGATION_LINK_SSU && generalLink.linkType === LinkFieldType.SSU) {
    return {
      ...base,
      url: generalLink.ssu,
      newWindow,
    } as SSULink;
  }

  logger.error('generalLinkToLink: Invalid link type', generalLink);
  return base as LinkType;
};
